export const DEFAULT_COMPANY_CONFIG = {
	'name': 'Jubilant Elderly Care Cheerful',
	'url': 'https://jubilant1.sparkscreation.com.hk',
	'logo': '/assets/img/logo.png',
	'bg': '/assets/img/bg.jpg',
  'serial_no': 'SYS-01'
}
